import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import axios from "axios";
import Cookies from "js-cookie";
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Dropdown} from "primereact/dropdown";
import {InputSwitch} from "primereact/inputswitch";
import {Calendar} from "primereact/calendar";
import {MultiSelect} from "primereact/multiselect";

import HelpComponent from "../HelpComponent";
import ThemeselectComponent from "../ThemeselectComponent";
import LangselectComponent from "../LangselectComponent";
import {Password} from "primereact/password";

const ProfileFormComponent = (props) => {

  const {t} = props;
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [roles, setRoles] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sendDailyDigestLoading, setSendDailyDigestLoading] = useState(false);

  const parseTimeValue = (timeValue) => {
    if (!timeValue) {
      return null;
    }
    const [hour, minute] = String(timeValue).split(':');
    if (hour === undefined || minute === undefined) {
      return null;
    }
    const parsedHour = Number(hour);
    const parsedMinute = Number(minute);
    if (Number.isNaN(parsedHour) || Number.isNaN(parsedMinute)) {
      return null;
    }
    const date = new Date();
    date.setHours(parsedHour, parsedMinute, 0, 0);
    return date;
  };

  const formatTimeValue = (dateValue) => {
    if (!dateValue) {
      return null;
    }
    const hour = String(dateValue.getHours()).padStart(2, '0');
    const minute = String(dateValue.getMinutes()).padStart(2, '0');
    return `${hour}:${minute}`;
  };

  const validate = (data) => {
    let errors = {};
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "profile/edit",
      newFormData,
      {
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
      .then(response => {
        setFormData(response.data.data);
        setNewFormData({})
        setLoading(false)
        window.App.toastShow('success', t('success'), response.data.message)
        window.App.setState({
          rerenderProfileList: Math.random(),
        })
        if (props.closeForm === true) {
          window.App.setState({
            sidebarProfileForm: false,
          })
        }
      })
      .catch(error => {
        setLoading(false)
        window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
      })
    form.restart();
  };

  const onManualSendDailyDigest = () => {
    setSendDailyDigestLoading(true);
    axios.post(
      process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "profile/send-daily-digest",
      {},
      {
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      }
    )
      .then(response => {
        setSendDailyDigestLoading(false);
        window.App.toastShow('success', t('success'), response.data.message);
      })
      .catch(error => {
        setSendDailyDigestLoading(false);
        window.App.toastShow('error', t('error'), error.response?.data?.message || error.toString(), '', error.response);
      });
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  useEffect(() => {
    setLoading(true)
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "profile",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setLoading(false)
        setFormData(response.data.data);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        setLoading(false)
      })

    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "user?item_per_page=9999",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setUsers(response.data.data.items || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [])

  return (
    <Form onSubmit={onSubmit} initialValues={formData}
          validate={validate} render={({handleSubmit}) => (
      <form onSubmit={handleSubmit} className="">
        <Panel className={"p-mt-3"}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6 p-col-align-center"}>
              <h2 className={"p-m-0"}>{t('profile_form')}</h2>
            </div>
            <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>
              <Button type="submit" aria-label={t('save')} icon={"pi pi-save"}
                      loading={loading}
                      onClick={() => {
                        props = {...props, closeForm: false}
                      }}
                      className="p-button-success p-ml-2"/>
              <Button type="button"
                      icon={"pi pi-times"}
                      onClick={() => {
                        window.App.setState({sidebarProfileForm: false});
                      }}
                      className="p-button-secondary close p-ml-2">
              </Button>
            </div>
          </div>
          {/*<HelpComponent type={"edit_box"}/>*/}
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <HelpComponent type={"field"} field={"name"}/>
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('name')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>
              <Field name="email" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <HelpComponent type={"field"} field={"email"}/>
                  <label htmlFor="email"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('email')}</label>
                  <span className="p-d-block">
                      <InputText id="email" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     email: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     email: e.target.value
                                   })
                                 }}
                                 value={formData.email}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>
              <Field name="contact_email" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <HelpComponent type={"field"} field={"contact_email"}/>
                  <label htmlFor="contact_email"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('contact_email')}</label>
                  <span className="p-d-block">
                      <InputText id="contact_email" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     contact_email: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     contact_email: e.target.value
                                   })
                                 }}
                                 value={formData.contact_email}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>
              <Field name="contact_phone" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <HelpComponent type={"field"} field={"contact_phone"}/>
                  <label htmlFor="contact_phone"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('contact_phone')}</label>
                  <span className="p-d-block">
                      <InputText id="contact_phone" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     contact_phone: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     contact_phone: e.target.value
                                   })
                                 }}
                                 value={formData.contact_phone}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12"}>
              <hr/>
            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>
              <Field name="plain_password" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <HelpComponent type={"field"} field={"plain_password"}/>
                  <label htmlFor="plain_password"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('new_password')}</label>
                  <span className="p-d-block">
                      <Password id="plain_password" {...input}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    plain_password: e.target.value
                                  })
                                  setNewFormData({
                                    ...newFormData,
                                    plain_password: e.target.value
                                  })
                                }}
                                value={formData.plain_password}
                                className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>
              <Field name="repeat_password" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <HelpComponent type={"field"} field={"repeat_password"}/>
                  <label htmlFor="repeat_password"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('password_check')}</label>
                  <span className="p-d-block">
                      <Password id="repeat_password" {...input}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    repeat_password: e.target.value
                                  })
                                  setNewFormData({
                                    ...newFormData,
                                    repeat_password: e.target.value
                                  })
                                }}
                                value={formData.repeat_password}
                                className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
        </Panel>
        <Panel className={"p-mt-3"}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6 p-col-align-center"}>
              <h2 className={"p-m-0"}>{t('settings')}</h2>
            </div>
            <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>

            </div>
          </div>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>
              <div className="p-field p-fluid">
                <label htmlFor="language"
                       className={""}>{t('language')}</label>
                <LangselectComponent/>
              </div>
            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>
              <div className="p-field p-fluid">
                <label htmlFor="name"
                       className={""}>{t('theme')}</label>
                <ThemeselectComponent/>
              </div>
            </div>
          </div>
        </Panel>


        {formData.master_user &&
          <Panel className={"p-mt-3"}>
            <div className={"p-grid"}>
              <div className={"p-col"}>
                <h2 className={"p-mt-0 p-mb-0"}>{t('daily_digest_email_header')}</h2>
              </div>
              <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>
                {/*<Button type="submit" aria-label={t('save_and_close')}*/}
                {/*        loading={loading}*/}
                {/*        onClick={() => {*/}
                {/*          props = {...props, closeForm: true}*/}
                {/*        }}*/}
                {/*        className="p-button-success p-ml-2">*/}
                {/*<span>*/}
                {/*  <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>*/}
                {/*</span>*/}
                {/*</Button>*/}
                <Button type="submit" aria-label={t('save')} icon={"pi pi-save"}
                        loading={loading}
                        onClick={() => {
                          props = {...props, closeForm: false}
                        }}
                        className="p-button-success p-ml-2"/>
              </div>
            </div>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-4"}>
                <Field name="daily_digest_email_enabled" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="daily_digest_email_enabled"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('daily_digest_email_enabled')}</label>
                    <span className="p-d-block p-mt-2">
                    <InputSwitch id="daily_digest_email_enabled"
                                 checked={!!formData.daily_digest_email_enabled}
                                 onChange={(e) => {
                                   const nextEnabled = e.value;
                                   const defaultSendTime = !formData.daily_digest_email_send_time && nextEnabled ? '06:00' : formData.daily_digest_email_send_time;
                                   setFormData({
                                     ...formData,
                                     daily_digest_email_enabled: nextEnabled,
                                     daily_digest_email_send_time: defaultSendTime
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     daily_digest_email_enabled: nextEnabled,
                                     daily_digest_email_send_time: defaultSendTime
                                   })
                                   setTimeout(() => {
                                     handleSubmit();
                                   }, 200)
                                 }}/>
                  </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              {formData.daily_digest_email_enabled &&
                <>
                  <div className={"p-col-12 p-lg-3"}>
                    <Field name="daily_digest_email_send_time" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="daily_digest_email_send_time"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('daily_digest_email_send_time')}</label>
                        <span className="p-d-block">
                    <Calendar id="daily_digest_email_send_time"
                              value={parseTimeValue(formData.daily_digest_email_send_time || '06:00')}
                              locale="default"
                              appendTo="self"
                              showIcon
                              showTime
                              timeOnly
                              hourFormat="24"
                              stepMinute={30}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  daily_digest_email_send_time: e.value ? formatTimeValue(e.value) : null
                                })
                                setNewFormData({
                                  ...newFormData,
                                  daily_digest_email_send_time: e.value ? formatTimeValue(e.value) : null
                                })
                              }}
                              className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                  </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                  <div className={"p-col-12 p-lg-5"}>
                    <Field name="daily_digest_recipients" render={({meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="daily_digest_recipients"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('daily_digest_recipients')}</label>
                        <span className="p-d-block">
                          <MultiSelect id="daily_digest_recipients"
                                       value={formData.daily_digest_recipients || []}
                                       options={users}
                                       appendTo="self"
                                       optionLabel="name"
                                       optionValue="id"
                                       showSelectAll
                                       placeholder={t('daily_digest_recipients_placeholder')}
                                       selectedItemsLabel={t('selected_items')}
                                       panelHeaderTemplate={(options) => (
                                         <div className={options.className}>
                                           <div className="p-d-flex p-ai-center">
                                             {options.checkboxElement}
                                             <span className="p-ml-2">{t('select_all')}</span>
                                           </div>
                                           {options.filterElement}
                                           {options.closeElement}
                                         </div>
                                       )}
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           daily_digest_recipients: e.value
                                         })
                                         setNewFormData({
                                           ...newFormData,
                                           daily_digest_recipients: e.value
                                         })
                                       }}/>
                        </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                  <div className={"p-col-12 p-py-0"}>
                    <hr/>
                  </div>
                  <div className={"p-col-12 p-text-right p-col-align-center"}>
                    <Button type="button"
                            id="manual_daily_digest_send"
                            icon="pi pi-envelope"
                            label={t('manual_daily_digest_send_button')}
                            loading={sendDailyDigestLoading}
                            onClick={onManualSendDailyDigest}
                            className="p-button-secondary"/>
                  </div>
                </>
              }
            </div>
          </Panel>
        }

      </form>
    )}
    />
  )
}
export default withTranslation('common')(ProfileFormComponent);
